import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title_waiting: 'Waiting Repair',
    title_begin_complete: 'Begin / Complete Repair',
    title_quality_control: 'Quality Control',
    title_hold: 'Hold Repair',
    title_vendor: 'Vendor Repair',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Repair',
        href: '/adm/opr/repair',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields_waiting: [
      {
        key: 'wo_no',
        label: 'WO No',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'app_date',
        label: 'App. Date',
        sortable: true,
      },
      {
        key: 'app_type',
        label: 'App. Type',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location',
        sortable: true,
      },
      {
        key: 'description',
        label: 'Description',
        sortable: true,
      },
    ],
    fields_begin_complete: [
      {
        key: 'repair_no',
        label: 'Repair No',
        sortable: true,
      },
      {
        key: 'repair_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'begin_repair',
        label: 'Begin',
        sortable: true,
      },
      {
        key: 'complete_repair',
        label: 'Complete',
        sortable: true,
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_hold: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'remark',
        label: 'Remark',
      },
      {
        key: 'status',
        label: 'Status',
      },
    ],
    items_vendor: [
      {
        id: 1,
        code: 'JWT',
        name: 'PT JAVA WIDYA TERANG',
        address: 'Jalan monginsidi no 44 surabaya',
        email: 'java@gmail.com',
        phone: '08572213342',
      },
      {
        id: 2,
        code: 'CSF',
        name: 'PT CAHAYA SINAR FAJAR',
        address: 'Jalan monginsidi no 44 surabaya',
        email: 'java@gmail.com',
        phone: '08572213342',
      },
    ],
    fields_vendor: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor Name',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    items_waiting: [
      {
        id: 1,
        wo_no: 'WO001210700001',
        principle: 'JBK',
        container: 'KLWU8894431',
        size: '20',
        type: 'GP',
        date_in: '2021-08-03',
        app_date: '2021-08-03',
        app_type: 'some',
        location: 'L101',
        description: '',
      },
      {
        id: 2,
        wo_no: 'WO001210700001',
        principle: 'JBK',
        container: 'WTYU8894431',
        size: '40',
        type: 'HC',
        date_in: '2021-08-03',
        app_date: '2021-08-03',
        app_type: 'approve',
        location: 'L101',
        description: '',
      },
      {
        id: 2,
        wo_no: 'WO001210700002',
        principle: 'BKT',
        container: 'KBWK6672213',
        size: '40',
        type: 'HC',
        date_in: '2021-08-03',
        app_date: '2021-08-03',
        app_type: 'approve',
        location: 'L101',
        description: '',
      },
    ],
    items_newdata: [
      {
        id: 1,
        code: 'WKL',
        container: 'KLTU4435562',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'new',
        begin: '',
        complete: '',
        remark: '',
      },
      {
        id: 2,
        code: 'WKL',
        container: 'DRYU7783341',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'new',
        begin: '',
        complete: '',
        remark: '',
      },
      {
        id: 3,
        code: 'WKL',
        container: 'KBJU5561123',
        size: 40,
        type: 'GP',
        wo_no: 'WO112',
        status: 'new',
        begin: '',
        complete: '',
        remark: '',
      },
    ],
    items_edit: [
      {
        id: 1,
        code: 'WKL',
        container: 'KLTU4435562',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'new',
        begin: '',
        complete: '',
        remark: '',
      },
      {
        id: 2,
        code: 'WKL',
        container: 'DRYU7783341',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'begin',
        begin: '06/08/2021',
        complete: '',
        remark: '',
      },
      {
        id: 3,
        code: 'WKL',
        container: 'KBJU5561123',
        size: 40,
        type: 'GP',
        wo_no: 'WO112',
        status: 'submission',
        begin: '04/08/2021',
        complete: '06/08/2021',
        remark: '',
      },
      {
        id: 4,
        code: 'WKL',
        container: 'RTWU998312',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'complete',
        begin: '04/08/2021',
        complete: '06/08/2021',
        remark: '',
      },
      {
        id: 5,
        code: 'WKL',
        container: 'WPRU9982213',
        size: 20,
        type: 'GP',
        wo_no: 'WO112',
        status: 'reject',
        begin: '04/08/2021',
        complete: '',
        remark: 'Bagian atas masih kurang rapi',
      },
    ],
    items_begin_complete: [
      {
        id: 1,
        repair_no: 'RE001210700001',
        repair_date: '2021-08-03',
        principle: 'JBK',
        container: 'KLWU8894431',
        size: '20',
        type: 'GP',
        begin_repair: '2021-08-03',
        status: 'progress',
      },
      {
        id: 1,
        repair_no: 'RE001210700001',
        repair_date: '2021-08-03',
        principle: 'JBK',
        container: 'WTYU8894431',
        size: '40',
        type: 'HC',
        begin_repair: '2021-08-01',
        complete_repair: '2021-08-03',
        status: 'submission',
      },
      {
        id: 2,
        repair_no: 'RE001210700002',
        repair_date: '2021-08-03',
        principle: 'BKT',
        container: 'KBWK6672213',
        size: '40',
        type: 'HC',
        begin_repair: '2021-08-01',
        complete_repair: '',
        status: 'reject',
      },
      {
        id: 2,
        repair_no: 'RE001210700002',
        repair_date: '2021-08-03',
        principle: 'BKT',
        container: 'JBKL8873342',
        size: '20',
        type: 'GP',
        begin_repair: '2021-08-01',
        complete_repair: '2021-08-01',
        status: 'complete',
      },
    ],
    items_quality: [
      {
        id: 1,
        repair_no: 'RE001210700001',
        repair_date: '2021-08-03',
        principle: 'JBK',
        container: 'KLWU8894431',
        size: '20',
        type: 'GP',
        begin_repair: '2021-08-03',
        complete_repair: '2021-08-03',
        status: 'submission',
      },
      {
        id: 2,
        repair_no: 'RE001210700001',
        repair_date: '2021-08-03',
        principle: 'JBK',
        container: 'WTYU8894431',
        size: '40',
        type: 'HC',
        begin_repair: '2021-08-01',
        complete_repair: '2021-08-03',
        status: 'submission',
      },
    ],
    items_holdrepair: [
      {
        id: 1,
        principle: 'JBK',
        container: 'KLWU8894431',
        size: '20',
        type: 'GP',
        remark: 'Pending untuk repair, masih proses pengajuan',
        status: 'hold',
      },
      {
        id: 2,
        principle: 'GBK',
        container: 'WKLU7723342',
        size: '40',
        type: 'GP',
        remark: 'Menunggu principle survey lokasi',
        status: 'hold',
      },
      {
        id: 3,
        principle: 'WBK',
        container: 'WRTU3342251',
        size: '40',
        type: 'GP',
        remark: '',
        status: 'release',
      },
    ],
    form_vendor_repair: {
      code: '',
      name: '',
      address: '',
      phone: '',
    },
    loading: false,
  },
};

export const getters = {
  form_vendor_repair(state) {
    return state.data.form_vendor_repair;
  },
};

export const mutations = {
  changeRepair(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchVendor(context, payload) {
    let result = await ApiGetRequest(`opr/vendor-repair`, payload);
    return !result.error ? result.data.object : [];
  },

  async getListVendorRepair({ commit, state }) {
    commit('changeRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/vendor-repair`, params);
    commit('changeRepair', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailVendorRepair({ commit }, payload = null) {
    commit('changeRepair', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/vendor-repair/${payload.id}`);
    commit('changeRepair', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createVendorRepair({ state, commit, dispatch }) {
    commit('changeRepair', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/vendor-repair`,
      state.data.form_vendor_repair
    );
    commit('changeRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateVendorRepair({ commit, state, dispatch }, payload = null) {
    commit('changeRepair', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/vendor-repair/${payload.id}`,
      state.data.form_vendor_repair
    );

    commit('changeRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteVendorRepair({ commit, dispatch }, payload = null) {
    commit('changeRepair', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/vendor-repair/${payload.id}`);
    commit('changeRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteRepair({ commit, dispatch }, payload = null) {
    commit('changeRepair', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repair/vendor/${payload.id}`);
    commit('changeRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
  async getWaitingRepair({ commit, state, dispatch }) {
    commit('changeRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/principle`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeRepair', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },
};
